import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Toggle from './../Toggle';
import Disclaimer from '../Disclaimer';
import { view10ImageOptions } from './views/view10'

class MastAndBoom extends Component {
    constructor(props) {
		super(props);
		this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this);
		this.handleSelfTackerChange = this.handleSelfTackerChange.bind(this);
    }

	handleMastAndBoomChange(newValue) {
		let configuration = this.props.configuration;
		configuration.MastAndBoom = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

	handleSelfTackerChange(event) {
		let configuration = this.props.configuration;
		configuration.SelfTacker = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

    render() {
		let imageOptions = view10ImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

					<h1><Trans defaults='Mast & Boom' /></h1>

					<h2><Trans defaults='Finish' /></h2>

					<RadioGroup options={this.props.mastAndBoomOptions} value={this.props.configuration.MastAndBoom} onChange={this.handleMastAndBoomChange} />

					<p><Trans defaults='**for optional furlerboom, please contact your local X-Yachts Dealer.' /></p>

					<h2><Trans defaults='Selftacking Track' /></h2>

					<p><Trans defaults='Self Tacking track recessed ‐ into the coachroof, curved track and Toulon ball bearing traveller, single sheet led aft via the mast to halyard winch (one side).' /></p>

					<Toggle checked={this.props.configuration.SelfTacker.value === 2} onChange={this.handleSelfTackerChange}>
						<Trans defaults='Selftacking track' />
					</Toggle>

                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(MastAndBoom);


// WEBPACK FOOTER //
// ./src/X43MK2/MastAndBoom.js